import cache from "@/store/cache.js";

export default {
  getAction(action) {
    if (action.action) {
      return action.action;
    }
    return action;
  },
  forBoards(action) {
    switch (this.getAction(action)) {
      case this.board.new:
      case this.board.move:
      case this.board.title.edit:
      case this.board.archive:
      case this.board.dearchive:
      case this.board.user.add:
      case this.board.user.delete:
      case this.user.activeBoard.change:
        return true;
    }

    return false;
  },
  forLists(action) {
    switch (this.getAction(action)) {
      case this.list.new:
      case this.list.move:
      case this.list.title.edit:
      case this.list.robotUrl.edit:
      case this.list.archive:
      case this.list.dearchive:
        return true;
    }

    return false;
  },
  forCards(action) {
    switch (this.getAction(action)) {
      case this.card.new:
      case this.card.move:
      case this.card.title.edit:
      case this.card.description.edit:
      case this.card.description.append:
      case this.card.archive:
      case this.card.dearchive:
        return true;
    }

    return false;
  },
  forCardMessages(action) {
    switch (this.getAction(action)) {
      case this.card.message.new:
        return true;
    }

    return false;
  },
  forFieldsTxt(action) {
    switch (this.getAction(action)) {
      case this.board.fieldTxt.new:
      case this.board.fieldTxt.edit:
      case this.card.fieldTxt.new:
      case this.card.fieldTxt.edit:
        return true;
    }

    return false;
  },
  forFieldsInt(action) {
    switch (this.getAction(action)) {
      case this.board.field.new:
      case this.board.field.edit:
      case this.card.fieldInt.new:
      case this.card.fieldInt.edit:
        return true;
    }

    return false;
  },
  forTheme(action) {
    switch (this.getAction(action)) {
      case this.user.theme.change:
        return true;
    }

    return false;
  },
  forFiles(action) {
    switch (this.getAction(action)) {
      case this.file.upload:
      case this.file.delete:
        return true;
    }

    return false;
  },
  forAlarms(action) {
    switch (this.getAction(action)) {
      case this.list.alarm.new:
      case this.list.alarm.update:
      case this.card.alarm.new:
      case this.card.alarm.update:
        return true;
    }

    return false;
  },
  forBotRiotLists(action) {
    switch (this.getAction(action)) {
      case this.list.botRiotList.new:
      case this.list.botRiotList.update:
        return true;
    }

    return false;
  },
  requireBoard(action) {
    switch (this.getAction(action)) {
      //boards
      case this.board.move:
      case this.board.title.edit:
      case this.board.archive:
      case this.board.dearchive:
      case this.board.user.add:
      case this.board.user.delete:
      case this.list.new:
        return true;
      //cards
      case this.card.new:
      case this.card.archive:
      case this.card.dearchive:
      case this.board.field.new:
      case this.board.field.edit:
      case this.board.fieldTxt.new:
      case this.board.fieldTxt.edit:
        return true;
    }

    return false;
  },
  requireList(action) {
    switch (this.getAction(action)) {
      case this.list.move:
      case this.list.title.edit:
      case this.list.robotUrl.edit:
      case this.list.archive:
      case this.list.dearchive:
      case this.list.alarm.new:
      case this.list.alarm.update:
      case this.card.new:
      case this.card.move:
      case this.card.archive:
      case this.card.dearchive:
      case this.card.alarm.new:
      case this.card.alarm.update:
      case this.botRiotList.new:
      case this.botRiotList.update:
        return true;
    }

    return false;
  },
  requireCard(action) {
    switch (this.getAction(action)) {
      //cards
      case this.card.move:
      case this.card.title.edit:
      case this.card.description.edit:
      case this.card.description.append:
      case this.card.archive:
      case this.card.dearchive:
      case this.card.message.new:
      case this.card.fieldInt.new:
      case this.card.fieldTxt.new:
      case this.card.alarm.new:
      case this.card.alarm.update:
      case this.file.delete:
      case this.file.upload:
        return true;
    }

    return false;
  },
  requireFor(rootState, event) {
    const action = this.getAction(event);

    const result = {
      board: null,
      list: null,
      card: null
    };

    if (event.board_id) {
      result.board = cache.boards.byId(event.board_id);
    }
    if (event.list_id) {
      result.list = cache.lists.byId(event.list_id);
    }
    if (event.card_id) {
      result.card = cache.cards.byId(event.card_id);
    }

    if (this.requireBoard(action) && !result.board) {
      console.log("I dont have board for this event", event);
      return null;
    }
    if (this.requireList(action) && !result.list) {
      console.log("I dont have list for this event", event);
      return null;
    }
    if (this.requireCard(action) && !result.card) {
      console.log("I dont have card for this event", event);
      return null;
    }

    return result;
  },
  getInfo(action) {
    let descr = this.infos.get(action);
    if (descr) return descr;

    const entities = ["board", "list", "card", "botRiotList", "file", "user"];

    entities.forEach(e => {
      const entity = this[e];
      Object.keys(entity).forEach(l1Key => {
        const l1 = entity[l1Key];
        if (typeof l1 == "number") {
          const info = {
            for: e,
            descriptionKey: l1Key,
            value: l1
          };
          info.description = this._getDescription(info);
          this.infos.set(l1, info);
        } else {
          Object.keys(l1).forEach(l2Key => {
            const l2 = l1[l2Key];
            if (typeof l2 == "number") {
              const info = {
                for: e,
                forSub: l1Key,
                descriptionKey: l2Key,
                value: l2
              };
              info.description = this._getDescription(info);
              this.infos.set(l2, info);
            }
          });
        }
      });
    });

    return this.infos.get(action);
  },
  _getDescription(info) {
    const translations = {
      new: "создать",
      edit: "редактировать",
      move: "передвинуть",
      archive: "в архив",
      dearchive: "из архива",
      moveNext: "в следующий",
      movePrev: "в предыдущий",
      append: "добавить",
      upload: "загрузить",
      delete: "удалить"
    };

    const forSubTranslations = {
      title: "заголовок",
      field: "поле",
      fieldInt: "поле",
      fieldTxt: "поле",
      user: "пользователь",
      alarm: "напоминание",
      description: "описание",
      message: "сообщение"
    };

    let description = translations[info.descriptionKey];
    if (!description) {
      description = info.descriptionKey;
    }

    if (info.forSub) {
      let subDescription = forSubTranslations[info.forSub];
      if (!subDescription) {
        subDescription = info.forSub;
      }
      description = subDescription + " " + description;
    }

    return description;
  },
  infos: new Map(),
  board: {
    new: 1000,
    move: 1001,
    title: {
      edit: 1002
    },
    archive: 1008,
    dearchive: 1009,
    field: {
      new: 8000,
      edit: 8001
    },
    fieldTxt: {
      new: 8500,
      edit: 8501
    },
    user: {
      add: 1100,
      delete: 1101
    }
  },
  list: {
    new: 2000,
    move: 2001,
    title: {
      edit: 2002
    },
    robotUrl: {
      edit: 2003
    },
    alarm: {
      new: 2100,
      update: 2101
    },
    botRiotList: {
      new: 6001,
      update: 6002
    },
    archive: 2008,
    dearchive: 2009
  },

  card: {
    new: 3000,
    title: {
      edit: 3002
    },
    description: {
      edit: 3003,
      append: 3004
    },
    move: 3001,
    archive: 3008,
    dearchive: 3009,
    moveNext: 3010,
    movePrev: 3011,
    fieldInt: {
      new: 4000,
      edit: 4001
    },
    fieldTxt: {
      new: 4500,
      edit: 4501
    },
    message: {
      new: 5000
    },
    alarm: {
      new: 3100,
      update: 3101
    }
  },

  botRiotList: {
    updateRoomId: 6000 //legacy
  },

  file: {
    upload: 7000,
    delete: 7001
  },

  user: {
    theme: {
      change: 9000
    },
    activeBoard: {
      change: 9001
    }
  }
};
